import type { ChatMessage } from 'shared/library/chat/types';

export function getInitialIntroduction(
  messages: readonly ChatMessage[],
  buyerId: number,
): ChatMessage | null {
  const first = messages[0];
  return first?.type === 'introduction' &&
    first.sender_id === buyerId &&
    first.body?.trim() &&
    !first.image &&
    !first.attachment
    ? first
    : null;
}

export function mergeMessages(current: ChatMessage[], incoming: ChatMessage[]) {
  const messages = new Map(current.map((message) => [message.id, message]));
  incoming.forEach((message) => messages.set(message.id, message));

  return Array.from(messages.values()).sort((left, right) => left.id - right.id);
}

export function createMessageClientId() {
  return (
    globalThis.crypto?.randomUUID?.() ??
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
      const random = Math.floor(Math.random() * 16);
      return (character === 'x' ? random : (random & 3) | 8).toString(16);
    })
  );
}
